import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';

export const labGuideItemNewRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/guide_items/new',
}).lazy(() =>
  import('pages/lab/GuideItems/LabGuideItemNewPage/LabGuideItemNewPage').then((d) => d.Route)
);
